import React, { useState, useEffect, useRef } from "react" 

import { withAuthenticator } from 'aws-amplify-react'
import Amplify, { API, graphqlOperation, Storage, Analytics, DataStore } from 'aws-amplify'
import Loader from 'react-loader-spinner'

import { listInspections, listVehicles, getUser, listCustomInspections, getInspectionByuId } from '../../graphql/queries';

import { generateQR, generatePDF} from "./generate"
import { 
    createNewVehicle, 
    editVehicle, 
    deleteCurrentVehicle, 
    createNewType,
    editType, 
    deleteSelectedType
} from "./mutate"

import { getStatus } from "../../util"
import { ThreeSixty } from "@material-ui/icons";

const awsmobile = {
  "aws_project_region": "us-east-2",
  "aws_cognito_identity_pool_id": "us-east-2:43d2d160-5ca1-4b5e-9e3a-a1513238d132",
  "aws_cognito_region": "us-east-2",
  "aws_user_pools_id": "us-east-2_huCRyNvO6",
  "aws_user_pools_web_client_id": "66qelm8iem6vm4mvvo1fjcv8cm",
  "oauth": {},
  "aws_user_files_s3_bucket": "ccv3-offline-s3-photostorage-sssdev",
  "aws_user_files_s3_bucket_region": "us-east-2",
  "aws_appsync_graphqlEndpoint": "https://qqqqrfhrz5cp3aberjgr5si2te.appsync-api.us-east-2.amazonaws.com/graphql",
  "aws_appsync_region": "us-east-2",
  "aws_appsync_authenticationType": "AWS_IAM",
};

Amplify.configure(awsmobile);

Analytics.disable()

function validateResponse(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

async function getPhoto(key) {
    if (!key) {
        return null
    }
    return new Promise(
        (resolve, reject) => {
            Storage.get(key.slice(7))
            .then(result => 
                fetch(result)
                .then(validateResponse)
                .then(response => 
                    response.text()
                    .then(photo => resolve(photo))))
            .catch(() => {
                reject(null)
            });
        }
    )
}

async function retrieveRawData(username) {
	return new Promise(
		(resolve, reject) => {
            API.graphql(graphqlOperation(getUser, { 
                id: username
            }))
            .then(user => {
                API.graphql(graphqlOperation(listVehicles, { 
                    filter: {
                        uId: {
                            eq: username
                        }
                    },
                    limit: 1000000
                }))
                .then(vehicles => {
                    API.graphql({
                        query: listInspections,
                        filter: {
                            uId: {
                                eq: username
                            }
                        },
                        variables: {
                          limit: 1000000
                        }})
                    .then(inspections => {
                        API.graphql({
                            query: listInspections,
                            filter: {
                                uId: {
                                    eq: username
                                }
                            },
                            variables: {
                              limit: 1000000,
                              nextToken: inspections.data.listInspections.nextToken
                            }})
                        .then(inspections1 => {
                            API.graphql({
                                query: listInspections,
                                filter: {
                                    uId: {
                                        eq: username
                                    }
                                },
                                variables: {
                                  limit: 1000000,
                                  nextToken: inspections1.data.listInspections.nextToken
                                }})
                            .then(inspections2 => {
                                API.graphql({
                                    query: listInspections,
                                    filter: {
                                        uId: {
                                            eq: username
                                        }
                                    },
                                    variables: {
                                      limit: 1000000,
                                      nextToken: inspections2.data.listInspections.nextToken
                                    }})
                                .then(inspections3 => {
                                    API.graphql({
                                        query: listInspections,
                                        filter: {
                                            uId: {
                                                eq: username
                                            }
                                        },
                                        variables: {
                                          limit: 1000000,
                                          nextToken: inspections3.data.listInspections.nextToken
                                        }})
                                    // .then(inspections4 => {
                                    //     API.graphql({
                                    //         query: listInspections,
                                    //         filter: {
                                    //             uId: {
                                    //                 eq: username
                                    //             }
                                    //         },
                                    //         variables: {
                                    //           limit: 1000000,
                                    //           nextToken: inspections4.data.listInspections.nextToken
                                    //         }})
                                        .then(inspections5 => {
                                            API.graphql(graphqlOperation(listCustomInspections, {
                                                filter: {
                                                    uId: {
                                                        eq: username
                                                    }
                                                },
                                                limit: 1000000
                                                // nextToken: inspections2.data.listInspections.nextToken
                                            }))
                                            .then(customInspections => {
                                                const uId = username
                                                const rawUser = user.data.getUser
                                                const rawCustomInspections = customInspections.data.listCustomInspections.items
                                                const rawVehicles = vehicles.data.listVehicles.items
                                                const duprawInspections = inspections.data.listInspections.items.concat(
                                                        inspections1.data.listInspections.items,
                                                        inspections2.data.listInspections.items,
                                                        inspections3.data.listInspections.items,
                                                        //inspections4.data.listInspections.items,
                                                        inspections5.data.listInspections.items
                                                    )
                                                const rawInspections = [...new Map(duprawInspections.map(v => [v.id, v])).values()];
                                                const nextToken = inspections5.data.listInspections.nextToken
                                                resolve({uId, rawUser, rawVehicles, rawInspections, rawCustomInspections, nextToken})
                                            })
                                        })
                                        .catch(err => reject("ListInspection",err))
                                    })
                                    .catch(err => reject("ListInspection",err))
                                })
                                .catch(err => reject("ListInspection",err))
                            })
                            .catch(err => reject("ListInspection",err))
                        // })
                        // .catch(err => reject("ListInspection",err))
                    })
                    .catch(err => reject("ListInspection",err))
                })
                .catch(err => reject("ListVehicle",err))
            })
            .catch(err => reject("GetUser",err))
		}
	)
}

function generateUser(user, vehicleCounter, inspectionCounter) {
    const today = new Date();
    var expiryDate = new Date(user.dateCreated)
    expiryDate = expiryDate.setDate(expiryDate.getDate() + 31);

    var daysLeft = Math.max(0, Math.ceil((expiryDate - today)/(60*60*24*1000)))
    daysLeft = (daysLeft === 0) ? "Expired, Please Contact Us!" : daysLeft

    return {
        tier: user.tier,
        daysLeft: daysLeft,
        vehiclesLeft: Math.max(0, Number(user.vehiclesLimit) - vehicleCounter),
        inspectionsLeft: Math.max(0, Number(user.inspectionsLimit) - inspectionCounter),
    }
}

function generateDicts(vehicles, inspections, customInspections) {

    const customDict = {
        "001" : { id: "0", fallback: "001", type: "Loader", items: ""},
        "002" : { id: "0", fallback: "002", type: "Excavator", items: ""},
        "003" : { id: "0", fallback: "003", type: "Rock Truck", items: ""},
        "004" : { id: "0", fallback: "004", type: "Crane", items: ""},
        "005" : { id: "0", fallback: "005", type: "Pickup Truck", items: ""},
        "006" : { id: "0", fallback: "006", type: "Towed Trailer", items: ""},
        "007" : { id: "0", fallback: "007", type: "General", items: ""},
        "008" : { id: "0", fallback: "008", type: "Single Unit Truck", items: ""},
        "009" : { id: "0", fallback: "009", type: "Small Passenger Vehicle", items: ""},
        "010" : { id: "0", fallback: "010", type: "School Bus", items: ""},
        "011" : { id: "0", fallback: "011", type: "General Tractor", items: ""},
        "012" : { id: "0", fallback: "012", type: "Motor Coach", items: ""},
        "013" : { id: "0", fallback: "013", type: "Mower", items: ""},
    }

    for (let customInd = 0; customInd < customInspections.length; customInd++) {
        const custom = customInspections[customInd]

        customDict[custom.id] = {
            id: custom.id,
            type: custom.type,
            fallback: custom.fallback,
            items: JSON.parse(custom.items)
        }
    }

    const vehicleDict = {}
    for (let vehicleInd = 0; vehicleInd < vehicles.length; vehicleInd++) {
        const vehicle = vehicles[vehicleInd]

        vehicleDict[vehicle.id] = {
            id: vehicle.id,
            vehicleData: JSON.parse(vehicle.data),
            UTCDate: "",
            lastDate: "",
            lastStatus: "",
            lastOdometer: "",
            lastDone: "",
            inspections: []
        }
    }

    const inspectionDict = {}

    for (let inspectionInd = 0; inspectionInd < inspections.length; inspectionInd++) {
        const inspection = inspections[inspectionInd]
        const insDate = new Date(inspection.date)
        const fDate = insDate.toLocaleString().slice(0,10)
        const fDateTime = fDate + "-" + insDate.toTimeString().slice(0, 5)
        

        if (inspection.vId in vehicleDict) {
            if (inspection.date > vehicleDict[inspection.vId].UTCDate) {
                vehicleDict[inspection.vId].UTCDate = inspection.date
                vehicleDict[inspection.vId].lastDate = fDate
                vehicleDict[inspection.vId].lastOdometer = inspection.odometer + "km"
                vehicleDict[inspection.vId].lastStatus = getStatus(inspection.status)

                const today = new Date()
                var lastDone = new Date(inspection.date)
                lastDone = Math.ceil((today - lastDone)/(1000*3600*24))
                vehicleDict[inspection.vId].lastDone = lastDone + " Days Ago"
            }


            vehicleDict[inspection.vId].inspections.push({
                id: inspection.id,
                vId: inspection.vId,
                name: fDate,
                status: getStatus(inspection.status),
                UTCdate: inspection.date,
                date: fDateTime,
                vehicleData: vehicleDict[inspection.vId].vehicleData,
                odometer: inspection.odometer + "km",
                metadata: JSON.parse(JSON.parse(inspection.metadata)).metadata,
                items: JSON.parse(JSON.parse(inspection.items))
            })

            inspectionDict[inspection.id] = {
                id: inspection.id,
                vId: inspection.vId,
                name: fDate,
                status: getStatus(inspection.status),
                UTCdate: inspection.date,
                date: fDateTime,
                vehicleData: vehicleDict[inspection.vId].vehicleData,
                odometer: inspection.odometer + "km",
                metadata: JSON.parse(JSON.parse(inspection.metadata)).metadata,
                items: JSON.parse(JSON.parse(inspection.items))
            }
        } 
    }

    return {inspectionDict, vehicleDict, customDict}
}

async function fetchInspections(username, nextToken, pInspections) {

    // const todoData = await API.graphql({
    //     query: listTodos,
    //     variables: {
    //       limit: 2,
    //       nextToken: "<token-id>"
    //     }
    //   })
    return new Promise(
		(resolve, reject) => {
            // API.graphql(graphqlOperation(listInspections, { 
            //     filter: {
            //         uId: {
            //             eq: username
            //         }
            //     },
            //     limit: 1000,
            //     nextToken: nextToken
            API.graphql({
                query: listInspections,
                variables: {
                  limit: 1000000,
                  nextToken: nextToken
                }}).then(inspections => {
                            const dinspections = pInspections.concat(
                                inspections.data.listInspections.items,
                                // inspections1.data.listInspections.items,
                                // inspections2.data.listInspections.items
                            )
                            const rInspections = [...new Map(dinspections.map(v => [v.id, v])).values()];
                            const nt = inspections.data.listInspections.nextToken
                            // const done = nt == null
                            const done = false
                            resolve({rInspections, nt, done})
                        })
                        .catch(err => reject("ListInspection",err))
                    })
            //         .catch(err => reject("ListInspection",err))
            //     })
            //     .catch(err => reject("ListInspection",err))
            // })
                       
}

function AWSData({ location, children, authData, ...rest }) {
    const [dicts, setDicts] = useState(0)
    const [user, setUser] = useState(0)
    const [loaded, setLoaded] = useState(true)
    const [uId, setUId] = useState(0)
    const [inspections, setInspections] = useState(0)
    const [vehicles, setVehicles] = useState(0)
    const [customInspections, setCustomInspections] = useState(0)
    const [nextToken, setNextToken] = useState(0)
    const [done, setDone] = useState(false)

    const search = location.search.slice(1)

	useEffect(() => {
		retrieveRawData(authData.username)
		.then(({uId, rawUser, rawVehicles, rawInspections, rawCustomInspections, nextToken}) => {
            setUId(uId);
            setDicts(generateDicts(rawVehicles, rawInspections, rawCustomInspections));
            setUser(generateUser(rawUser, rawVehicles.length, rawInspections.length));
            setLoaded(false);
            setInspections(rawInspections);
            setVehicles(rawVehicles);
            setCustomInspections(rawCustomInspections);
            setNextToken(nextToken);
            setDone(false);
        })
        .catch(err => console.log(err))
	}, [authData.username])


    const childrenWithData = React.Children.map(children, (child) => {
        if (child.type) {
            return React.cloneElement(child, { 
                dicts:dicts, 
                user:user,
                done:done,
                nInsp: 0,
                fetchInspections: () => fetchInspections(authData.username, nextToken, inspections).then(
                    ({rInspections, nt, done})=> {

                        setDicts(generateDicts(vehicles, rInspections, customInspections));
                        setInspections(rInspections);
                        setNextToken(nt);
                        setDone(done);
                    }).catch(err => console.log(err)),
                createVehicle: (vehicleData) => createNewVehicle(uId, vehicleData),
                editVehicle: (vehicleData) => editVehicle(search, vehicleData),
                deleteVehicle: () => deleteCurrentVehicle(search),
                createNewType: (typeDetails) => createNewType(uId, typeDetails),
                editType: (iId, typeDetails) => editType(iId, typeDetails),
                deleteSelectedType: (iId) => deleteSelectedType(iId),
                getPhoto: (key) => getPhoto(key),
                generateQR: (vIds) => generateQR(uId, dicts.vehicleDict, dicts.customDict, vIds),
                generateInspection: (
                    inspection,
                    startDate = new Date(),
                    endDate = new Date(), 
                    workorder = true,
                ) => generatePDF(inspection, dicts.customDict, startDate, endDate, workorder, (key) => getPhoto(key)),
            })
        } else {
            return child
        }
    })

    if (loaded) {
        return (
            <div style={{textAlign:"center"}}>
                <Loader
                    type="Puff"
                    color="#00BFFF"
                    height={100}
                    width={100}
                    timeout={10000} //10 secs
                />
            </div>
        )
    } 

    return (
        <main>{childrenWithData}</main>
    )
}

export default withAuthenticator(AWSData)